import React from 'react';
import styles from './StrategyStats.module.css';
import Spinner from '../../common/Spinner/Spinner';

const StrategyStats = ({ totalStrategies = 0, activeStrategies = 0, signalsToday = 0, onSignalsClick, loading = false }) => {
  const stats = [
    {
      icon: 'stacks',
      value: totalStrategies,
      label: 'Total Strategies',
    },
    {
      icon: 'play_circle',
      value: activeStrategies,
      label: 'Active Strategies',
    },
    {
      icon: 'notifications_active',
      value: signalsToday,
      label: 'Signals Today',
      onClick: onSignalsClick,
    },
  ];

  if (loading) {
    return (
      <div className={styles.container}>
        {stats.map((stat, index) => (
          <div key={index} className={styles.card}>
            <div className={styles.shimmer} />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {stats.map((stat, index) => (
        <div
          key={index}
          className={`${styles.card} ${stat.onClick ? styles.clickable : ''}`}
          onClick={stat.onClick}
          role={stat.onClick ? 'button' : undefined}
          tabIndex={stat.onClick ? 0 : undefined}
          onKeyDown={stat.onClick ? (e) => {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); stat.onClick(); }
          } : undefined}
        >
          <div className={styles.iconWrapper}>
            <span className="material-symbols-outlined">{stat.icon}</span>
          </div>
          <div className={styles.info}>
            <span className={styles.value}>{stat.value}</span>
            <span className={styles.label}>{stat.label}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StrategyStats;
